import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { application } from "src/stimulus/application";

// landIeul: components/uiParts/ImageModal 相当。
// カセットの外観カルーセル / 虫眼鏡クリック (data-action="click->site--image-modal#open") で
// 全画面オーバーレイ (overlay target) を開き、初回のみ内部の swiper を初期化する。
class SiteImageModalController extends Controller<HTMLElement> {
  static targets = ["overlay", "swiper"];

  declare readonly overlayTarget: HTMLElement;
  declare readonly swiperTarget: HTMLElement;

  swiper?: Swiper;

  open(): void {
    this.overlayTarget.style.display = "block";
    if (this.swiper) return;
    const scoped = (sel: string) =>
      Array.from(this.swiperTarget.querySelectorAll<HTMLElement>(sel));
    this.swiper = new Swiper(this.swiperTarget, {
      modules: [Navigation, Pagination],
      navigation: {
        prevEl: scoped(".swiper-button-prev"),
        nextEl: scoped(".swiper-button-next"),
        disabledClass: "ImageModal_disabledClass",
      },
      pagination: { el: this.swiperTarget.querySelector<HTMLElement>(".swiper-pagination") },
    });
  }

  close(): void {
    this.overlayTarget.style.display = "none";
  }
}

application.register("site--image-modal", SiteImageModalController);
